import { render, staticRenderFns } from "./Projects.yaml?vue&type=template&id=025b6cb8&component"
import script from "./Projects.yaml?vue&type=script&lang=ts&component"
export * from "./Projects.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports